import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Loading from 'react-loading-animation'
import { DebounceInput } from 'react-debounce-input'

import { updateReservationAndQuery } from 'actions/reservation'
import { validateCouponCodeAction } from 'actions/coupons'

class CouponCodeInput extends React.Component {
  constructor(props) {
    super(props)
    this.couponCode = ''
  }

  componentDidMount() {
    this.validateUserCoupon()
  }

  componentDidUpdate() {
    this.validateUserCoupon()
  }

  validateUserCoupon() {
    const { reservationData, validateCoupon } = this.props

    if (reservationData.coupon_code !== this.couponCode) {
      this.couponCode = reservationData.coupon_code
      validateCoupon()
    }
  }

  couponUpdated(couponData) {
    const { updateReservation } = this.props
    const { value } = couponData.target

    updateReservation({ data: { coupon_code: value.toUpperCase() } })
  }

  render() {
    const { coupon, reservationData, width, highlightOnSuccess, className } = this.props
    const highlightClass = coupon.ticket && highlightOnSuccess ?
      'form__coupon-input--highlighted' : ''
    const icon = coupon.ticket ? 'ok' : null

    return (
      <div className={'form__field '} style={{ position: 'relative', width }}>
        <DebounceInput
          type="text"
          className={`form__coupon-input ${className} ${highlightClass}`}
          minLength={3}
          debounceTimeout={100}
          onChange={this.couponUpdated.bind(this)}
          value={reservationData.coupon_code.toString()}
          style={{ textTransform: 'uppercase' }}
        />
        <div
          style={{
            position: 'absolute',
            right: '10px',
            top: '10px',
          }}
        >
          <Loading isLoading={coupon.validating} width="20px" height="20px">
            <i className={`icon icon--${icon}`} style={{ fontSize: '20px', marginTop: '-5px' }}></i>
          </Loading>
        </div>
      </div>
    )
  }
}

CouponCodeInput.propTypes = {
  width: PropTypes.string,
  highlightOnSuccess: PropTypes.bool,
  className: PropTypes.string,
  coupon: PropTypes.object.isRequired,
  reservationData: PropTypes.object.isRequired,
  updateReservation: PropTypes.func.isRequired,
  validateCoupon: PropTypes.func.isRequired,
}

function mapStateToProps(state) {
  return {
    coupon: state.reservation.coupon,
    reservationData: state.reservation.data,
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    updateReservation: updateReservationAndQuery,
    validateCoupon: validateCouponCodeAction,
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(CouponCodeInput)
